import * as React from "react";
import { ActionList, ActionItemButton } from "@conserveit/blocks";
import { connect } from "react-redux";
import {
  snoozeEquipRules,
  SNOOZE_OPTIONS,
} from "../../redux/modules/_BETA/snooze";
import { unsnoozeEquipRules } from "../../redux/modules/_BETA/unsnooze";
import * as Redux from "redux";
interface DispatchProps {
  snooze(ids: number[], duration: number, cb?: () => void): () => void;
  unsnooze(ids: number[], cb?: () => void): () => void;
}

interface OwnProps {
  equipRuleIds: number[];
  showSnooze: boolean;
  showUnsnooze: boolean;
  onClick?: () => void;
}

type Props = OwnProps & DispatchProps;

const SnoozeMenuComp: React.FunctionComponent<Props> = (props) => (
  <React.Fragment>
    <ActionList>
      {props.showSnooze &&
        Object.values(SNOOZE_OPTIONS).map((o) => (
          <ActionItemButton
            key={o.value}
            onClick={props.snooze(props.equipRuleIds, o.value, props.onClick)}
          >
            {o.label}
          </ActionItemButton>
        ))}
      {props.showUnsnooze && (
        <ActionItemButton
          onClick={props.unsnooze(props.equipRuleIds, props.onClick)}
        >
          Unsnooze now
        </ActionItemButton>
      )}
    </ActionList>
  </React.Fragment>
);

SnoozeMenuComp.defaultProps = {
  showSnooze: true,
  showUnsnooze: false,
};

function mapDispatchToProps(dispatch: Redux.Dispatch): DispatchProps {
  return {
    snooze: (equipRuleIds, duration, cb) => () => {
      dispatch(snoozeEquipRules({ equipRuleIds, duration }));
      if (cb) cb();
    },
    unsnooze: (equipRuleIds, cb) => () => {
      dispatch(unsnoozeEquipRules({ equipRuleIds }));
      if (cb) cb();
    },
  };
}

const SnoozeMenu = connect(undefined, mapDispatchToProps)(SnoozeMenuComp);
export { SnoozeMenu };
